import React from "react";
import moment from "moment";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { STATUS_ORDER } from "config/constant";

const HeaderHistoryOrder = ({ item }) => {
	const classes = useStyles();
	return (
		<React.Fragment>
			<Grid classes={{ root: classes.border }} style={{ left: -8 }} />
			<Grid classes={{ root: classes.root }}>
				<Grid classes={{ root: classes.header }}>
					<Grid classes={{ root: classes.times }}>
						<img src={Images.icClock} alt={"icClock"} />
						{moment(item?.createTime).format("HH:mm, DD/MM/YYYY")}
					</Grid>
					<Grid
						classes={{ root: classes.status }}
						style={{
							backgroundColor: STATUS_ORDER[item?.status]?.color
						}}
					>
						{STATUS_ORDER[item?.status]?.statusName}
					</Grid>
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.border }} style={{ right: -8 }} />
		</React.Fragment>
	);
};

export default HeaderHistoryOrder;
